import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import GetAllLegalViewTypesInteractor from "../interactor/GetAllLegalViewTypesInteractor";
import ShowSuccessMessageInteractor from "../../core/interactor/notifications/ShowSuccessMessageInteractor";
import CreateLegalViewTypeInteractor from "../interactor/CreateLegalViewTypeInteractor";
import UpdateLegalViewTypeInteractor from "../interactor/UpdateLegalViewTypeInteractor";
import { IDocumentType } from "../../documentTypes/model/DocumentType";

export interface TLegalViewTypesPresenter extends TLoadingAwarePresenter {
  legalViewTypes: IDocumentType[];
}

export interface ILegalViewTypesPresenter
  extends TLegalViewTypesPresenter,
    TPresentable {
  loadAllLegalViewTypes(legalViewTypes: IDocumentType[]): void;
  createLegalViewType(data: IDocumentType): void;
  updateLegalViewType(data: IDocumentType): void;
}

const defaultState: TLegalViewTypesPresenter = { legalViewTypes: [] };

const LegalViewTypesPresenter = withStore<
  ILegalViewTypesPresenter,
  TLegalViewTypesPresenter
>(({ application, store, loader, translate }): ILegalViewTypesPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<
    TLegalViewTypesPresenter & TLoadingAwarePresenter
  >();
  loader.start("legalViewTypeLoader");
  const loadAllLegalViewTypes = (legalViewTypes: IDocumentType[]) => {
    _store.update({ legalViewTypes });
    loader.stop("legalViewTypeLoader");
  };

  const getAllLegalViewTypes = async () => {
    let legalViewTypes = await _application.container
      .resolve<GetAllLegalViewTypesInteractor>("getAllLegalViewTypes")
      .execute();
    loadAllLegalViewTypes(legalViewTypes);
  };

  const createLegalViewType = async (legalViewType: IDocumentType) => {
    await _application.container
      .resolve<CreateLegalViewTypeInteractor>("createLegalViewType")
      .execute(legalViewType);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project_member.create_success_message"));

    await getAllLegalViewTypes();
  };
  const updateLegalViewType = async (legalViewType: IDocumentType) => {
    await _application.container
      .resolve<UpdateLegalViewTypeInteractor>("updateLegalViewType")
      .execute(legalViewType);
    _application.container
      .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
      .execute(translate("editors.project_member.create_success_message"));

    await getAllLegalViewTypes();
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadAllLegalViewTypes,
    createLegalViewType,
    updateLegalViewType
  };
}, defaultState);

export default LegalViewTypesPresenter;
